import React from 'react'
import t from '../../../../../../translations/main'
import { Trans } from 'react-i18next'
import utils from 'src/components/Organisms/Form/utils'

import Font from 'src/components/Core/Typography/Font/Font'
import InputFilesGroup from 'src/views/Forms/Components/InputFilesGroup/InputFilesGroup'
import DropdownWrapper from 'src/views/Atoms/CountryDropdown/DropdownWrapper'

import globalConfig from '../../../../../../components/Organisms/Form/config'
import globalConsts from '../../../globalConsts'
import { DELIVERABLE_SEND_FILE_URL } from 'src/views/Pages/Onboarding/flowConfig'
import { ConfigCompanyDetails } from '../../../CorporateAccount/CompanyDetails/types'
import { ApiData } from 'src/views/Pages/Onboarding/types'

const ChartNoteText = (
  <Font
    key='chartNoteText'
    ellipsis={false}
  >
    {/* @ts-ignore */}
    <Trans i18nKey={'onboarding.forms.CorporateAccount.CompanyOwnershipForm.visualOnly.chartNote'} />
  </Font>
)

const config = (
  { countries }: ConfigCompanyDetails,
  onFileUpload: (args?: ApiData, i?: number, data?: number) => void,
  onFileDelete: (obj?: Record<string, unknown>) => void
) => utils.injectTranslation({
  id: 'AddShareholderDetailsForm',
  path: 'onboarding.forms.CorporateAccount.CompanyOwnershipForm.inputs',
  keysToRemove: ['documentName'],
  content: [
    {
      componentType: 'grid',
      props: {
        gridTemplateColumns: '1fr 1fr',
      },
      content: [
        {
          componentType: 'input',
          props: {
            name: 'name',
            required: true,
          },
        },
        {
          componentType: 'input',
          transformType: 'stringToNumOrViceVersa',
          submitValidation: 'number',
          props: {
            name: 'ownershipPercentage',
            errorLabelEllipsis: 'false',
            pattern: globalConfig?.regex?.percentage,
            required: true,
          },
        },
      ],
    },
    {
      componentType: 'grid',
      content: [
        {
          componentType: 'input',
          props: {
            name: 'shareholderResidentialAddress',
            required: true,
            isTextarea: true,
            textAreaHeight: '32px',
            textAreaPointerEvents: 'auto',
            resize: 'none'
          },
        },
      ]
    },
    {
      componentType: 'grid',
      props: {
        gridTemplateColumns: '1fr 1fr 1fr',
      },
      content: [
        {
          componentType: 'input',
          props: {
            name: 'shareholderTown',
            required: true,
          },
        },
        {
          componentType: 'input',
          props: {
            name: 'shareholderPostcode',
            required: true,
          },
        },
        {
          componentType: 'input',
          props: {
            name: 'shareholderCountry',
            required: true,
          },
          // @ts-ignore
          custom: props => DropdownWrapper({
            options: countries,
            name: 'shareholderCountry',
            label: 'onboarding.forms.CorporateAccount.CompanyOwnershipForm.inputs.shareholderCountry.label',
            placeholder: 'onboarding.forms.CorporateAccount.CompanyOwnershipForm.inputs.shareholderCountry.placeholder',
            required: true,
            bgTransparent: true,
            filter: true,
            ...props
          }),
        },
      ],
    },
    {
      componentType: 'grid',
      props: {
        gridTemplateColumns: '1fr 1fr',
      },
      content: [
        {
          componentType: 'date',
          submitValidation: 'date',
          transformType: 'date',
          props: {
            name: 'shareholderDateOfBirth',
            noFuture: true,
            required: true,
            dontClearValue: true,
          },
        },
      ],
    },
    {
      componentType: 'grid',
      content: [
        {
          componentType: 'radioGroup',
          props: {
            name: 'isUBOOwnershipDirect',
            dataList: [
              {
                id: 'isUBOOwnershipDirect1',
                label: t('components.forms.labels.yes'),
                value: 'true',
              },
              {
                id: 'isUBOOwnershipDirect2',
                label: t('components.forms.labels.no'),
                value: 'false',
              },
            ],
            required: true,
          },
        },
      ],
    },
    {
      componentType: 'grid',
      props: {
        boxSizing: 'border-box',
        padding: '0 0 0 4%',
        gridTemplateColumns: '1fr',
      },
      content: [
        {
          componentType: 'input',
          props: {
            name: 'entityStateName',
            required: true,
          },
        },
        {
          componentType: '',
          visualComponent: ChartNoteText,
          visualName: 'chartNoteText'
        },
        {
          componentType: 'input',
          props: {
            name: globalConsts.INPUT_FILES_CORPORATE_OWNERSHIP_CSCDOCUMENT,
          },
          custom: props => InputFilesGroup({
            inputMargin: '8px 0 24px 0',
            inputLabel: t('onboarding.forms.CorporateAccount.CompanyOwnershipForm.files.chart.inputLabel'),
            singleFileInput: true,
            fetchOptions: {
              requestConfig: {
                url: DELIVERABLE_SEND_FILE_URL
              }
            },
            step: '5',
            name: globalConsts.INPUT_FILES_CORPORATE_OWNERSHIP_CSCDOCUMENT,
            customSignatureOnChange: onFileUpload,
            customOnDelete: onFileDelete,
            flowKeyProp: 'CorporateAccount',
            ...props
          }),
          visualName: 'chartFile'
        },
      ],
    }
  ],
})

export default config
